

function TitleTable() {
    return (
        <div className="flex flex-row-reverse items-center bg-primary-500 text-white text-right p-2">
            <p className="w-10"></p>
            <p className="w-64">نام سازمان</p>
            <p className="w-52">شناسه</p>
            {/* <p className="w-44">نوع</p> */}
            {/* <p className="w-52">نام کاربری</p> */}
            <p className="w-52">شماره موبایل</p>
            <p className="w-52">IP</p>
            {/* <p className="w-32">اتصال</p> */}
            <p className="w-52">زمان ایجاد</p>
            <p className="w-52">زمان بروز رسانی</p>
            <p className="w-52"></p>
        </div>
    )
}
export default TitleTable;